<div class="button-toolbar">

  <div class="toolbox-container">
    <div class="buttons-container">
      <div class="btn-group" role="group">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Reset
          </button>

          <ul class="dropdown-menu">
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reload the application from the server">
                <a class="dropdown-item" (click)="onButtonAction('resetApplication','')">Application</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reset the section currently selected">
                <a class="dropdown-item" (click)="onButtonAction('resetSection','')">Section</a>
              </span>
            </li>

          </ul>
        </span>
      </div>

      <button *ngIf="isTreeNodeXEVPRMImportedMessage()" type="button" class="btn btn-light"
        aria-label="Reload an XEVPRM message in the Create and Send Products section" title="Reload"
        (click)="onButtonAction('reloadImport',selectedNode)">Reload</button>


      <button type="button" class="btn btn-light" *ngIf="!isListViewNode() && isRemoveAllowed()"
        aria-label="Remove the results items from the list" title="Remove the results items from the list"
        (click)="onButtonAction('remove',selectedNode)">Remove</button>

      <button type="button" class="btn btn-light" *ngIf="showRemoveItemsWebtraderNodeButton()"
        aria-label="Remove all selected elements from the list" title="Remove selected item(s) from the Tree View Area"
        (click)="onButtonAction('removeall', selectedNode)">Remove</button>

      <button type="button" class="btn btn-light" *ngIf="isConditionsNode();" aria-label="Run query" title="Run query"
        (click)="onButtonAction('runQuery', selectedNode)">Run</button>

      <button type="button" class="btn btn-light" *ngIf="isResultNode();" aria-label="Re-Run Query"
        title="Use this functionality to launch the existing query again"
        (click)="onButtonAction('runQuery', selectedNode)">ReRun</button>

      <button type="button" class="btn btn-light" *ngIf="isResultNode();" aria-label="Modify Query Criteria"
        title="Use this functionality to modify the criteria of your previous query"
        (click)="onButtonAction('moveToConditionsNode', selectedNode)">Modify</button>

      <button type="button" class="btn btn-light" *ngIf="isConditionsNode();"
        aria-label="To export the results of the query in an excel file" title="To export the results of the query in an excel file"
        (click)="onButtonAction('runToExcel', selectedNode)">Run to Excel</button>

      <button type="button" class="btn btn-light" *ngIf="isResultNode();"
        aria-label="Export query result as excel spreadsheet" title="Export query result as excel spreadsheet"
        (click)="onButtonAction('exportToExcel', selectedNode)">Excel</button>

      <button type="button" class="btn btn-light" *ngIf="isRefreshAllowed();" aria-label="Refresh Lookup"
        title="Refresh" (click)="onButtonAction('refreshQuery', selectedNode)">Refresh</button>

      <button type="button" class="btn btn-light" *ngIf="isLocalImportNode();"
        aria-label="Import a message file from the local computer" title="Import a message file from the local computer"
        (click)="onButtonAction('localImport',selectedNode)">Local Import</button>

      <button type="button" class="btn btn-light" *ngIf="isRemoteImportNode();"
        aria-label="Load the selected item(s) in the tree view area"
        title="Load the selected item(s) in the tree view area"
        (click)="onButtonAction('remoteImport',selectedNode)">Remote Import</button>

      <div class="d-inline-block" title="Select All">
        <button *ngIf="showSelectAll()" class="square-button btn btn-light" aria-label="Select All"
          (click)="onButtonAction('selectAll',selectedNode)" [disabled]="!isEnabledSelectAll(selectedNode)">
          &#x2611;
        </button>
      </div>

      <div class="d-inline-block" title="Deselect All">
        <button *ngIf="showDeselectAll()" class="square-button btn btn-light" aria-label="Deselect All"
          title="Deselect All" (click)="onButtonAction('deselectAll',selectedNode)"
          [disabled]="!isEnabledDeselectAll(selectedNode)">
          &#x2610;
        </button>
      </div>

      <button type="button" class="btn btn-light" title="Sort conditions alphabetically" *ngIf="showSortButton()"
        (click)="onButtonAction('sortField', selectedNode, sortOrder)">
        <span *ngIf="sortOrder" class="bi bi-sort-alpha-down"></span>
        <span *ngIf="!sortOrder" class="bi bi-sort-alpha-up"></span>
      </button>

      <button type="button" class="btn btn-light" *ngIf="isImportMessageWithErrors(selectedNode);"
        aria-label="See errors during the import" title="See errors during the import"
        (click)="onButtonAction('validate',selectedNode)">See Errors</button>

      <p-dialog header="Select file" [(visible)]="displayDialog" [modal]="true" [closable]="true" width="400px" (onHide)="onDialogClose()">
        <app-local-file-selector (fileContentChange)="onFileContentChange($event)"></app-local-file-selector>
        <p-footer class="footer-centered-button">
          <button aria-label="Upload File" type="button" *ngIf="fileContent!=''" pButton label="Upload File"
            (click)="onButtonAction('loadMessage',fileContent)"></button>
        </p-footer>
      </p-dialog>

    </div>

    <div class="pagination-container" *ngIf="isPaginationAllowed()">
      <button type="button" class="btn btn-light" aria-label="Back to top" title="Back to top"
        (click)="onButtonAction('topPage',selectedNode)"><i class="pi pi-arrow-up"></i></button>

      <button type="button" class="btn btn-light" aria-label="Get previous Page" title="Get previous Page"
        (click)="onButtonAction('previousPage',selectedNode)"><i class="pi pi-arrow-left"></i></button>

      <button type="button" class="btn btn-light" aria-label="Get next Page" title="Get next Page"
        (click)="onButtonAction('nextPage',selectedNode)"><i class="pi pi-arrow-right"></i></button>
    </div>

  </div>